import api from '@/services/api';
import { 
  Folder, 
  FolderWithChildren, 
  CreateFolderRequest, 
  UpdateFolderRequest, 
  AddJobsToFolderRequest,
  RemoveJobsFromFolderRequest
} from '@/types/folders';

export const getFolders = async (): Promise<Folder[]> => {
  try {
    const response = await api.get('/api/folders/');
    return response.data.results || response.data;
  } catch (error) {
    console.error('Error fetching folders:', error);
    throw error;
  }
};

export const getRootFolders = async (): Promise<FolderWithChildren[]> => {
  try {
    const response = await api.get('/api/folders/root/');
    return response.data;
  } catch (error) {
    console.error('Error fetching root folders:', error);
    throw error;
  }
};

export const getFolderTree = async (folderId: string): Promise<FolderWithChildren> => {
  try {
    const response = await api.get(`/api/folders/${folderId}/tree/`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching folder tree for folder ${folderId}:`, error);
    throw error;
  }
};

export const createFolder = async (folderData: CreateFolderRequest): Promise<Folder> => {
  try {
    const response = await api.post('/api/folders/', folderData);
    return response.data;
  } catch (error) {
    console.error('Error creating folder:', error);
    throw error;
  }
};

export const updateFolder = async (folderId: string, folderData: UpdateFolderRequest): Promise<Folder> => {
  try {
    const response = await api.patch(`/api/folders/${folderId}/`, folderData);
    return response.data;
  } catch (error) {
    console.error(`Error updating folder ${folderId}:`, error);
    throw error;
  }
};

export const deleteFolder = async (folderId: string): Promise<void> => {
  try {
    await api.delete(`/api/folders/${folderId}/`);
  } catch (error) {
    console.error(`Error deleting folder ${folderId}:`, error);
    throw error;
  }
};

export const getFolderJobs = async (folderId: string) => {
  try {
    const response = await api.get(`/api/folders/${folderId}/jobs/`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching jobs for folder ${folderId}:`, error);
    throw error;
  }
};

export const addJobsToFolder = async (folderId: string, jobIds: string[]): Promise<void> => {
  try {
    const request: AddJobsToFolderRequest = { job_ids: jobIds };
    await api.post(`/api/folders/${folderId}/add_jobs/`, request);
  } catch (error) {
    console.error(`Error adding jobs to folder ${folderId}:`, error);
    throw error;
  }
};

export const removeJobsFromFolder = async (folderId: string, jobIds: string[]): Promise<void> => {
  try {
    const request: RemoveJobsFromFolderRequest = { job_ids: jobIds };
    await api.post(`/api/folders/${folderId}/remove_jobs/`, request);
  } catch (error) {
    console.error(`Error removing jobs from folder ${folderId}:`, error);
    throw error;
  }
};

export const searchFolders = async (query: string): Promise<Folder[]> => {
  try {
    const response = await api.get(`/api/folders/search/?q=${encodeURIComponent(query)}`);
    return response.data;
  } catch (error) {
    console.error(`Error searching folders with query "${query}":`, error);
    throw error;
  }
}; 